import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../components/PageLoader";

const DBNBizCatalogMappings = ({ orgRegistry }: any) => {
  const navigate = useNavigate();
  const [orgRegistryCatalogsList, setOrgRegistryCatalogsList] = useState<any>([]);
  const [columnDefs, setColumnDefs] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text', callback: handleEditCatalogMapping },
      { field: 'Price', headerName: 'Price', searchField: 'Price', sortable: true, filter: true, filterType: 'number', },
      { field: 'StockQuantity', headerName: 'Stock Quantity', searchField: 'StockQuantity', sortable: true, filter: true, filterType: 'number', },
      { field: 'VendorName', headerName: 'Vendor Name', searchField: 'VendorName', sortable: true, filter: true, filterType: 'text', },
      { field: 'IsPublished', headerName: 'Published', cellRenderer: 'yesNoRenderer', filter: true },
      { field: 'Evaluation.Ratings.Rates', headerName: 'Ratings', sortable: true, filter: true, filterType: 'number', },
      { field: 'Gtin', headerName: 'Gtin', searchField: 'Gtin', sortable: true, filter: true, filterType: 'text', },
      { field: 'Sku', headerName: 'SKU', searchField: 'Sku', sortable: true, filter: true, filterType: 'text', },
      { field: 'ShortDescription', headerName: 'Short Description', searchField: 'ShortDescription', sortable: true, filter: true, filterType: 'text' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, searchField: 'CreatedOnUtc', sortable: true, filter: true, filterType: 'date', },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true, searchField: 'ModifiedOnUtc', sortable: true, filter: true, filterType: 'date', }
    ]);
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Catalog Mapping</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleAdd = () => {
    navigate(`/management/catalog/products/${0}`)
  }

  const handleEditCatalogMapping = (data: any) => {
    navigate(`/management/catalog/products/${data?.Id}`)
  }

  useEffect(() => {
    createColumnDefs();
    setOrgRegistryCatalogsList(orgRegistry?.Catalog)
  }, [orgRegistry])

  return (
    <>
      {orgRegistry?.isLoading ? <PageLoader /> :
        <Table
          key={refreshKey}
          columnData={columnDefs}
          rowData={orgRegistryCatalogsList}
          enableFilter={true}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          additionButtons={additionButtons}
          headingName="DBNBiz Catalog Mappings"
        />
      }
    </>
  );
};

export default DBNBizCatalogMappings;


